/*
 * @Description:
 * @Version: 1.0
 * @Author: zhuangyuan
 * @Date: 2021-07-02 15:11:56
 * @LastEditors: zhuangyuan
 * @LastEditTime: 2021-07-02 15:54:32
 * @FilePath: \cqliving-community-h5\src\common\mixin.ts
 */
import Vue from "vue";
import store from "../store";
import native from "./Native";
Vue.mixin({
  beforeRouteEnter(to: any, from: any, next) {
    if (to.meta.title) {
      native.setTile(to.meta.title);
    }
    //如果是需要缓存的页面，则记录滚动条高度
    if (to.meta.needToken && store.state.Token) {
      if (to.meta.keepAlive) {
        const content = document.getElementById("app");
        if (content) {
          next(vm => {
            content.scrollTop = to.meta.scrollTop;
          });
        }
      } else {
        next();
      }
    } else {
      if (to.meta.needToken) {
        native.goToken().then(result => {
          store.commit("SET_STATE", {
            sessionId: result.sessionId,
            Token: result.token
          });
          next();
        });
      } else {
        if (to.meta.keepAlive) {
          const content = document.getElementById("app");
          if (content) {
            next(vm => {
              content.scrollTop = to.meta.scrollTop;
            });
          }
        } else {
          next();
        }
      }
    }
  },
  beforeRouteLeave(to: any, from: any, next) {
    if (to.path == "/") {
      native.close();
    }
    //如果是需要缓存的页面，滚动到上次保存的高度
    if (from.meta.keepAlive) {
      const content = document.getElementById("app");
      if (content) {
        from.meta.scrollTop = content.scrollTop;
      }
    }
    next();
  }
});
